import { createContext, useContext, useMemo } from "react";
import { useQuery, useMutation } from "@tanstack/react-query";
import { getAbout, updateAbout } from "../../api/about";
import { getIntialValues, generatePayload } from "./helper";
import useToaster from "../../components/alert";
import Const from "../../utils/constant";

const PageContext = createContext();

export const PageProvider = ({ children }) => {
  const toaster = useToaster();

  const getAboutQuery = useQuery({
    queryKey: ["about"],
    queryFn: getAbout,
  });

  const updateAboutMutation = useMutation({
    mutationFn: updateAbout,
    onSuccess: () => {
      toaster.success(Const.MESSAGES.SUCCESS, Const.MESSAGES.DATA_IS_UPDATED_SUCCESSFULLY);
      getAboutQuery.refetch();
    },
    onError: () => {
      toaster.error(Const.MESSAGES.FAILED, "Error updating About Us page.");
    },
  });

  const initialValues = useMemo(() => {
    const aboutData = getAboutQuery?.data?.data || {};
    return getIntialValues(aboutData);
  }, [getAboutQuery?.data]);

  const handleSubmit = (values) => {
    const payload = generatePayload(values);
    updateAboutMutation.mutate(payload);
  };

  return (
    <PageContext.Provider
      value={{
        initialValues,
        handleSubmit,
        updateAboutQuery: updateAboutMutation,
      }}
    >
      {children}
    </PageContext.Provider>
  );
};

export const usePageProvider = () => {
  return useContext(PageContext);
};
